<!-- 资金管理-扣除記錄 -->
<template>
  <div>
    <page :url="url"
          :form="form"
          @reset="reset"
          :sort-info="{ prop: 'createTimeL', order: 'descending' }">
      <template slot="tableSearch">
        <el-form-item :label="$t('text.orderNumber')">
          <el-input v-model="form.orderId" :placeholder="$t('text.orderNumber')" maxlength="50"></el-input>
        </el-form-item>

        <el-form-item :label="$t('text.date')">
          <el-date-picker v-model="timeDate"
                          type="daterange"
                          format="yyyy-MM-dd"
                          value-format="yyyyMMdd"
                          :range-separator="$t('text.to')"
                          :start-placeholder="$t('text.startDate')"
                          :end-placeholder="$t('text.endDate')"
                          @change="timeChange"/>
        </el-form-item>
      </template>

      <template slot="tableColumn">

        <el-table-column
            width="250"
            prop="id"
            :label="$t('text.reductionRecordId')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="250"
            prop="orderId"
            :label="$t('text.orderNumber')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="orderAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.orderAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="currentBalance"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.afterBalance')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="createTimeFormat"
            :label="$t('text.creationTime')"
            align="center"
        ></el-table-column>
      </template>
    </page>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";

export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/creditDeductionRecord/selectList",
      timeDate: [],
      form: {
        orderId: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>